export default {
      id: "note.sprite-usage",
      viewBox: "0 0 25 27",
      url: __webpack_public_path__ + "sprite.svg#note.sprite-usage",
      toString: function () {
        return this.url;
      }
    }